import React, { createContext, useState } from "react";

// Create Context
export const UserContext = createContext();



// Context Provider Component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Retrieve user session from localStorage
    
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });
  
  const [cartUpdated, setCartUpdated] = useState(false);
  // Function to log in a user and save session
  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData)); // Save session to localStorage
  };

  // Function to log out a user and clear session
  const logout = () => {
    setUser(null);
    localStorage.removeItem("user"); // Clear session
    localStorage.removeItem("shopSettings");
    window.location.href = "/login";
  };

  
  return (
    <UserContext.Provider value={{ user, login, logout,cartUpdated,setCartUpdated  }}>
      {children}
    </UserContext.Provider>
  );
};
